import gql from 'graphql-tag'

export default gql`
  mutation deleteSearchHistory($input: DeleteSearchHistoryInput!) {
    deleteSearchHistory(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`
